import { render, staticRenderFns } from "./Pagos.vue?vue&type=template&id=a71e737c&scoped=true"
import script from "./Pagos.vue?vue&type=script&lang=js"
export * from "./Pagos.vue?vue&type=script&lang=js"
import style0 from "./Pagos.vue?vue&type=style&index=0&id=a71e737c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71e737c",
  null
  
)

export default component.exports